import { createApiSlice } from "@common";
import {
  CURD_ADDRESS,
  CURD_ADDRESS_BY_ID,
  CURD_ADDRESS_DETAILS_BY_ID
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addAddress",
    method: "post",
    url: CURD_ADDRESS,
    stateKey: "message",
  },
  {
    name: "getAddressById",
    method: "get",
    url: CURD_ADDRESS_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateAddress",
    method: "put",
    url: CURD_ADDRESS,
    stateKey: "message",
  },
  {
    name: "deleteAddress",
    method: "delete",
    url: CURD_ADDRESS,
    stateKey: "message",
  },
  {
    name: "getAddressDetails",
    method: "get",
    url: CURD_ADDRESS_DETAILS_BY_ID,
    stateKey: "details",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "address",
  apiConfig,
  customReducers,
);
const addressSlice = slice;
// Export the slice's reducer
export default addressSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addAddress,
  getAddressById,
  updateAddress,
  deleteAddress,
  getAddressDetails,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
